export default __webpack_public_path__ + "static/competitive_gaming-11f8436e95a25e35abf2b4acdedee900.jpg";